window.dataLayer = window.dataLayer || [];
window.uetq = window.uetq || [];
function gtag() {
	// eslint-disable-next-line prefer-rest-params
	window.dataLayer.push(arguments);
}

if (
	localStorage.getItem("consentMode") === null ||
	parseInt(localStorage.getItem("consentModeExpiry"), 10) < Date.now()
) {
	localStorage.removeItem("consentMode");
	localStorage.removeItem("consentModeExpiry");
}

gtag("consent", "default", {
	ad_storage: "denied",
	ad_user_data: "denied",
	ad_personalization: "denied",
	analytics_storage: "denied",
	personalization_storage: "denied",
	wait_for_update: 2000,
});

// Bing
window.uetq.push("consent", "default", {
	ad_storage: "denied",
});
